// // import Echo from 'laravel-echo';
// // import Pusher from 'pusher-js';

// // window.Pusher = Pusher;

// // // const echo = new Echo({
// // //     broadcaster: 'reverb',
// // //     key: process.env.REACT_APP_REVERB_APP_KEY,
// // //     wsHost: process.env.REACT_APP_REVERB_HOST,
// // //     wsPort: process.env.REACT_APP_REVERB_PORT ?? 8080,
// // //     wssPort: process.env.REACT_APP_REVERB_PORT ?? 443,
// // //     forceTLS: (process.env.REACT_APP_REVERB_SCHEME ?? 'https') === 'https',
// // //     enabledTransports: ['ws', 'wss'],
// // // });

// // const echo = new Echo({
// //     broadcaster: 'reverb',
// //     key: process.env.REACT_APP_REVERB_APP_KEY,
// //     wsHost: process.env.REACT_APP_REVERB_HOST,
// //     wsPort: process.env.REACT_APP_REVERB_PORT ?? 8080,
// //     wssPort: process.env.REACT_APP_REVERB_PORT ?? 443,
// //     forceTLS: (process.env.REACT_APP_REVERB_SCHEME ?? 'https') === 'https',
// //     enabledTransports: ['ws', 'wss'],

// //     // 🔥 ADD THIS (MOST IMPORTANT)
// //     // authEndpoint: "http://localhost:8000/api/broadcasting/auth",
// //     authEndpoint: "https://api.quest-connect.com/api/broadcasting/auth",

// //     // 🔥 ADD THIS (FOR SANCTUM TOKEN)
// //     auth: {
// //         headers: {
// //             Authorization: `Bearer ${localStorage.getItem("authToken")}`,
// //             Accept: 'application/json',
// //         },
// //         // 🔥 YE LINE ADD KAREIN
// //         withCredentials: true,
// //     },
// // });

// // export default echo;


// import Echo from 'laravel-echo';
// import Pusher from 'pusher-js';

// window.Pusher = Pusher;

// // let echoInstance = null;

// if (!window.__ECHO__) {
//     window.__ECHO__ = null;
// }

// const getEcho = () => {
//     const token = localStorage.getItem("authToken");

//     // Bina token ke Echo initialize nahi karna hai
//     if (!token) {
//         // if (echoInstance) {
//         //     echoInstance.disconnect();
//         //     echoInstance = null;
//         // }
//         if (window.__ECHO__) {
//             window.__ECHO__.disconnect();
//             window.__ECHO__ = null;
//         }

//         return null;
//     }

//     // Naya instance agar nahi bana hai to banayein
//     // if (!echoInstance) {
//     //     echoInstance = new Echo({
//     if (!window.__ECHO__) {
//         window.__ECHO__ = new Echo({
//             broadcaster: 'reverb',
//             key: process.env.REACT_APP_REVERB_APP_KEY,
//             wsHost: process.env.REACT_APP_REVERB_HOST,
//             wsPort: process.env.REACT_APP_REVERB_PORT ?? 8080,
//             wssPort: process.env.REACT_APP_REVERB_PORT ?? 443,
//             forceTLS: (process.env.REACT_APP_REVERB_SCHEME ?? 'https') === 'https',
//             enabledTransports: ['ws', 'wss'],

//             authEndpoint: "https://api.quest-connect.com/api/broadcasting/auth",

//             auth: {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     Accept: 'application/json',
//                 },
//                 withCredentials: true,
//             },
//         });

//         console.log("🟢 Echo instance created");

//         // ================= DEBUG LOGS START =================
//         // const pusherConnection = echoInstance.connector.pusher.connection;
//         // const pusherConnection = window.__ECHO__.connector.pusher.connection;

//         // pusherConnection.bind('state_change', (states) => {
//         //     console.log("🔄 STATE CHANGE:", states.previous, "➡️", states.current);
//         // });

//         // pusherConnection.bind('connected', () => {
//         //     console.log("✅ CONNECTED SUCCESSFULLY");
//         // });

//         // pusherConnection.bind('disconnected', () => {
//         //     console.log("❌ DISCONNECTED");
//         // });

//         // pusherConnection.bind('error', (error) => {
//         //     console.error("🚨 CONNECTION ERROR:", error);
//         // });

//         // pusherConnection.bind('connecting', () => {
//         //     console.log("⏳ CONNECTING...");
//         // });

//         // pusherConnection.bind('unavailable', () => {
//         //     console.warn("⚠️ SERVER UNAVAILABLE");
//         // });

//         // pusherConnection.bind('failed', () => {
//         //     console.error("💥 CONNECTION FAILED");
//         // });

//         const pusherConnection = window.__ECHO__.connector.pusher.connection;

//         // 🔥 bind ONLY ONCE
//         if (!window.__ECHO_DEBUG_BOUND__) {
//             window.__ECHO_DEBUG_BOUND__ = true;

//             pusherConnection.bind('state_change', (states) => {
//                 console.log("🔄 STATE:", states.previous, "➡️", states.current);
//             });

//             pusherConnection.bind('connected', () => {
//                 console.log("✅ CONNECTED");
//             });

//             pusherConnection.bind('error', (error) => {
//                 console.error("🚨 ERROR:", error);
//             });
//         }
//         // ================= DEBUG LOGS END =================
//     }

//     // return echoInstance;
//     return window.__ECHO__;
// };

// export default getEcho;

import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { API_URL } from "./config";


window.Pusher = Pusher;

// ===============================
// 🔥 GLOBALS
// ===============================
if (!window.__ECHO__) {
    window.__ECHO__ = null;
}

const channel = new BroadcastChannel("echo_channel");
let isMaster = false;

// ===============================
// 🔥 MASTER ELECTION
// ===============================
const electMaster = () => {
    const existing = localStorage.getItem("echo_master");

    if (!existing) {
        localStorage.setItem("echo_master", Date.now());
        isMaster = true;
        console.log("👑 MASTER TAB");
    } else {
        isMaster = false;
        console.log("👥 SLAVE TAB");
    }
};

// ===============================
// 🔥 MAIN FUNCTION
// ===============================
const getEcho = () => {
    const token = localStorage.getItem("authToken");
    const reverbKey = process.env.REACT_APP_REVERB_APP_KEY?.trim();
    const reverbHost = process.env.REACT_APP_REVERB_HOST?.trim();

    // ❌ no token → disconnect
    if (!token) {
        if (window.__ECHO__) {
            window.__ECHO__.disconnect();
            window.__ECHO__ = null;
        }
        return null;
    }

    // Pusher throws during construction when the Reverb key is missing.
    // Keep the rest of the dashboard usable when realtime is not configured.
    if (!reverbKey || !reverbHost) {
        console.warn(
            "Realtime notifications disabled: REACT_APP_REVERB_APP_KEY and REACT_APP_REVERB_HOST are required."
        );
        return null;
    }

    // 👑 decide master/slave
    electMaster();

    // ===============================
    // 👥 SLAVE TAB
    // ===============================
    if (!isMaster) {
        console.log("🚫 SLAVE → no socket");

        // 👉 listen from master
        channel.onmessage = (event) => {
            console.log("📡 From MASTER:", event.data);

            // 👉 future: toast / redux / state update
        };

        return null;
    }

    // ===============================
    // 👑 MASTER TAB
    // ===============================
    if (!window.__ECHO__) {
        window.__ECHO__ = new Echo({
            broadcaster: 'reverb',
            key: reverbKey,
            wsHost: reverbHost,
            wsPort: process.env.REACT_APP_REVERB_PORT ?? 8080,
            wssPort: process.env.REACT_APP_REVERB_PORT ?? 443,
            forceTLS: (process.env.REACT_APP_REVERB_SCHEME ?? 'https') === 'https',
            enabledTransports: ['ws', 'wss'],

            // authEndpoint: "https://api.quest-connect.com/api/broadcasting/auth",
            authEndpoint: `${API_URL}/broadcasting/auth`,

            auth: {
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: 'application/json',
                },
                withCredentials: true,
            },
        });

        console.log("🟢 Echo CREATED (MASTER)");

        const pusherConnection = window.__ECHO__.connector.pusher.connection;

        if (!window.__ECHO_DEBUG_BOUND__) {
            window.__ECHO_DEBUG_BOUND__ = true;

            pusherConnection.bind('connected', () => {
                console.log("✅ CONNECTED");
            });

            pusherConnection.bind('error', (error) => {
                console.error("🚨 ERROR:", error);
            });
        }
    }

    return window.__ECHO__;
};

// ===============================
// 🔥 CLEANUP ON TAB CLOSE
// ===============================
window.addEventListener("beforeunload", () => {
    if (isMaster) {
        localStorage.removeItem("echo_master");
    }
});

export default getEcho;
